import { createContext } from 'react';

export const PlayerPortalsActionsContext = /*#__PURE__*/ createContext<{
  API: any; // formApi
  FormCTAConfig: any;
}>({
  API: null,
  FormCTAConfig: null,
});
